import React from 'react';
import { CalendarDays } from 'lucide-react';
import { TabMonthEnd } from './Billing';

// Standalone page for the month-end statement run (was a Billing tab).
export default function MonthEnd() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <CalendarDays size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Month-end</h1>
          <p className="text-xs text-gray-400">Review and email statements to clients for a month</p>
        </div>
      </div>
      <TabMonthEnd />
    </div>
  );
}
